export default "__VITE_ASSET__5e7afcc0__"